import { TableProperties } from "exceljs";
import { 
  buildExcelTable, 
  genEmptyRow,
  getOrderedExportColumns,
  mapColumnsToExportFormat,
} from "../../services/exporter";
import { ReportRecord } from "../../slices/reports";
import axios from "axios";
import {
  createRequestWithAuthHeaders,
  getFullUrl,
} from "../../configs/axios-export.custom";
import { buildQuery } from "../../utils/Helpers/queryBuilder";
import { ColumnsSettingsData, DataColumnConfigProps } from "../../components/MaterialTable/Table";
import { getReportsColumnsConfig } from "./reportsColumns.config";

export const getSortableColumnPropertyName = (
  _propertyName: string,
): string => {
  return _propertyName;
};

export function getReportsDownloadUrlFromId(id: string) {
  return `https://konektid-dec-resources.s3.amazonaws.com/${id.replace(
    /-/g,
    "",
  )}.pdf`;
}

export function getExportableDataTableReports(
  data: ReportRecord[],
  savedColumnSettings?: ColumnsSettingsData[] | null,
): TableProperties {
  // Get default columns configuration
  const defaultColumns = getReportsColumnsConfig(getSortableColumnPropertyName);
  
  // Get ordered and filtered columns based on user settings
  const orderedColumns = getOrderedExportColumns(savedColumnSettings, defaultColumns);

  // Define data accessors for each column property
  const dataAccessors: { [propertyName: string]: (record: ReportRecord) => any } = {
    link: (record) => getReportsDownloadUrlFromId(record.uniqueId),
    country: (record) => record.country,
    title: (record) => record.title,
    documentType: (record) => record.documentType,
    publicationDate: (record) => record.publicationDate ? record.publicationDate.substring(0, 10) : "",
    authoringOrganization: (record) => record.authoringOrganization,
    personalAuthors: (record) =>
      record.personalAuthors
        ? record.personalAuthors.replace(/ \|\| /g, "; ")
        : "",
    technicalSectors: (record) =>
      record.technicalSectors
        ? record.technicalSectors.replace(/ \|\| /g, "; ")
        : "",
    abstract: (record) => record.abstract,
    contractGrantNumber: (record) => record.contractGrantNumber,
    contractGrantNumberEvaluated: (record) => record.contractGrantNumberEvaluated,
  };

  // Map columns and data to export format
  const { columns, rows } = mapColumnsToExportFormat(orderedColumns, data, dataAccessors);

  return buildExcelTable("DataExport", columns, rows);
}

export async function getExcelDataReports(
  context,
  queryDto,
  totalItems: number = 1000,
): Promise<any[]> {
  const q = queryDto;
  if (q) {
    q.pageSize = totalItems;
    q.pageIndex = 0;
  }
  let result = Array<any>();
  await axios
    .get(
      getFullUrl(`/api/Dec${buildQuery({ ...q }, "|")}`, {
        useDedicatedEnvironment: true,
      }),
      createRequestWithAuthHeaders(context),
    )
    .then((response) => {
      result = response.data.data;
    })
    .catch((error) => {
      alert("error fetching data");
    });
  return result;
}
